<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconTranscript_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M15.632 2c-1.689 0-3.308.67-4.502 1.865L4.993 10a.91.91 0 0 0-.266.643v7.343l-2.46 2.461a.909.909 0 1 0 1.285 1.286l2.453-2.454h7.359a.909.909 0 0 0 .643-.267l6.127-6.145A6.367 6.367 0 0 0 15.632 2Zm2.443 3.917a.985.985 0 0 1 0 1.393l-5.607 5.592h3.168a.91.91 0 1 1 0 1.818h-4.992l-2.632 2.624c-.083.09-.128.135-.172.135H6.601c-.097 0-.177 0-.177-.089v-1.062c0-.088.016-.147.132-.264h.001L16.682 5.916a.985.985 0 0 1 1.393 0Z"
        clip-rule="evenodd"
    />
</svg>
